import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { kalkulationsblaetterSelector } from 'store/lookups/selector';
import { formStyles } from 'styles/formStyles';

interface KalkulationsblattByBlattProps {
    label: string;
    disabled: boolean;
    value: string | null;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: string) => void;
}

export const KalkulationsblattByBlatt: React.FC<KalkulationsblattByBlattProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const kalkulationsblaetter = useSelector(kalkulationsblaetterSelector);

    const options = React.useMemo(() => {
        const o = kalkulationsblaetter
            .sort((ka, kb) => ka.blatt.localeCompare(kb.blatt))
            .map((k) => ({
                value: k.blatt,
                label: k.blatt,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [kalkulationsblaetter, allowEmpty]);

    return (
        <>
            <Label className={disabled ? formStyles.labelDisabled : ''}>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value || '',
                              label: value || '',
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
